import { render, staticRenderFns } from "./datetime.vue?vue&type=template&id=b863b53c&scoped=true"
import script from "./datetime.vue?vue&type=script&lang=js"
export * from "./datetime.vue?vue&type=script&lang=js"
import style0 from "./datetime.vue?vue&type=style&index=0&id=b863b53c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b863b53c",
  null
  
)

export default component.exports